import React from "react";
import { useEffect } from "react";
import envVariables from "../../data/envVariables";
import Button from "../ui/Button";
import { isDealPreAvinode } from "../../utilities/settings";

const PortalFinanceStageBasedCtas = ({ deal, onShowOptions }) => {
    const legId = deal.daM_Ref;
    const downloadInvoiceUrl = `${envVariables.documentBase}/api/invoice/download-invoice-jsr?legId=${legId}`;

    const pb1InvoicePdf = deal.post_Booking_Invoice_1_URL;
    const pb2InvoicePdf = deal.post_Booking_Invoice_2_URL;
    const pb3InvoicePdf = deal.post_Booking_Invoice_3_URL;

    useEffect(() => {
        //console.log(deal)
    }, [deal]);

    const openInvoiceDL = () => {
        window.open(downloadInvoiceUrl, "_blank");
    };
    const openPbInvoice1Pdf = () => {
        window.open(pb1InvoicePdf, "_blank");
    };
    const openPbInvoice2Pdf = () => {
        window.open(pb2InvoicePdf, "_blank");
    };
    const openPbInvoice3Pdf = () => {
        window.open(pb3InvoicePdf, "_blank");
    };

    return (
        <>
            <div className="portal-cta-grid">
                {!isDealPreAvinode(deal) && (
                    <Button classNames={["button button--secondary"]} onClick={openInvoiceDL}>
                        Invoice PDF
                    </Button>
                )}
                {!isDealPreAvinode(deal) && deal.additional_Flight_Costs_Number && (
                    <Button classNames={["button button--secondary"]} onClick={openPbInvoice1Pdf}>
                        PB Invoice 1 PDF
                    </Button>
                )}
                {!isDealPreAvinode(deal) && deal.post_booking_Invoice_2_Price_number && (
                    <Button classNames={["button button--secondary"]} onClick={openPbInvoice2Pdf}>
                        PB Invoice 2 PDF
                    </Button>
                )}
                {!isDealPreAvinode(deal) && deal.post_booking_Invoice_3_Price_number && (
                    <Button classNames={["button button--secondary"]} onClick={openPbInvoice3Pdf}>
                        PB Invoice 3 PDF
                    </Button>
                )}
            </div>
        </>
    );
};

export default PortalFinanceStageBasedCtas;
